var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "700px" },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function ({ on, attrs }) {
              return [_vm._t("clickable", null, { on: on, attrs: attrs })]
            },
          },
        ],
        null,
        true
      ),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "rounded-t-0",
          attrs: {
            "data-cy": _vm.create ? "createGroupForm" : "updateGroupForm",
          },
        },
        [
          _c(
            "v-card-title",
            {
              staticClass: "headline mitreSecondaryBlue",
              attrs: { "data-cy": "groupModalTitle", "primary-title": "" },
            },
            [_vm._v(_vm._s(_vm.title))]
          ),
          _c(
            "v-card-text",
            [
              _c("br"),
              _c(
                "v-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "8" } },
                        [
                          _c("v-text-field", {
                            attrs: { "data-cy": "name", label: "Group Name" },
                            on: { input: _vm.checkUniqueName },
                            model: {
                              value: _vm.groupInfo.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.groupInfo, "name", $$v)
                              },
                              expression: "groupInfo.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "span",
                                        _vm._g({}, on),
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              "data-cy": "public",
                                              label: "Make Publicly Visible?",
                                            },
                                            model: {
                                              value: _vm.groupInfo.public,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.groupInfo,
                                                  "public",
                                                  $$v
                                                )
                                              },
                                              expression: "groupInfo.public",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " This will make the group name visible to all logged in users. It will not expose any results or profiles added to the group. "
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-textarea", {
                    attrs: {
                      "data-cy": "desc",
                      label: "Description",
                      rows: "1",
                      "auto-grow": "",
                    },
                    model: {
                      value: _vm.groupInfo.desc,
                      callback: function ($$v) {
                        _vm.$set(_vm.groupInfo, "desc", $$v)
                      },
                      expression: "groupInfo.desc",
                    },
                  }),
                  _c("Users", {
                    attrs: {
                      editable: true,
                      create: _vm.create,
                      admin: _vm.admin,
                    },
                    on: {
                      "on-update-group-user-role": _vm.updateSaveState,
                      "delete-user-confirm": _vm.updateSaveState,
                    },
                    model: {
                      value: _vm.groupInfo.users,
                      callback: function ($$v) {
                        _vm.$set(_vm.groupInfo, "users", $$v)
                      },
                      expression: "groupInfo.users",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              !_vm.create && _vm.apiKeysEnabled
                ? _c("GroupAPIKeysModal", {
                    attrs: { group: _vm.group },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "clickable",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        "data-cy": "groupAPIKeys",
                                        color: "primary",
                                        text: "",
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [_vm._v(" Manage API Keys ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3777224457
                    ),
                  })
                : _vm._e(),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    "data-cy": "closeAndDiscardChanges",
                    color: "primary",
                    text: "",
                  },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    "data-cy": "closeAndSaveChanges",
                    color: "primary",
                    text: "",
                    disabled: !_vm.saveable || _vm.duplicateName,
                  },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }